import styled from "styled-components";

export const TitleBlockWrapper = styled.p`
  padding: 0;
  margin: 0;
  align-self: flex-start;
  font-weight: 700;
  font-size: 37px;
  line-height: 45px;
  color: #000000;
`;
